export const lowercaseRegexp: RegExp = /[a-z]/;
